/**
 * 1.8.5 (D-1.8.5-3) — My settings, for the tech: "Email me about new tickets" (on). His own choice, kept on the server
 * (PUT /api/me/settings { ticketEmails }), apart from the display choices. Off: no ticket email, whatever Admin →
 * Settings says; new tickets still show as New in the app. The outcome is said in the live region.
 */
import { useId, useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import type { MeResponse } from '@shared/admin';
import { ticketEmailsOn, type MySettings } from '@shared/my-settings';
import { send, useMeExtras } from '@/lib/admin';
import { ApiRequestError } from '@/lib/api';
import { useAnnounce } from '@/components/Announcer';

export function TicketEmailsField() {
  const { t } = useTranslation();
  const id = useId();
  const me = useMeExtras();
  const qc = useQueryClient();
  const announce = useAnnounce();
  const [busy, setBusy] = useState(false);
  const on = ticketEmailsOn(me.data?.settings);
  const change = async (next: boolean) => {
    setBusy(true);
    try {
      const out = await send<MySettings>('/api/me/settings', 'PUT', { ticketEmails: next });
      qc.setQueryData<MeResponse>(['me-extras'], (d) => (d ? { ...d, settings: out } : d));
      announce(next ? t('visit185.emailsOnSaved') : t('visit185.emailsOffSaved'));
    } catch (err) {
      announce(t('visit185.emailsFailed', { why: err instanceof ApiRequestError ? err.message : String(err) }), 'assertive');
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="field" data-testid="ticket-emails-field">
      <label className="switch" htmlFor={`${id}-on`}>
        <input id={`${id}-on`} type="checkbox" checked={on} disabled={busy || me.isLoading} onChange={(e) => void change(e.currentTarget.checked)} aria-describedby={`${id}-help`} data-testid="ticket-emails" />
        <span>{t('visit185.emailsLabel')}</span>
      </label>
      <p className="help" id={`${id}-help`}>
        {t('visit185.emailsHelp')}
      </p>
    </div>
  );
}
